"use client";
import BtcPanelSideMenu from "@/app/components/BtcPanelSideMenu";
import Chart from "@/app/components/Chart";
import InvestingSignals from "@/app/components/InvestingSignals";
import { BTCPrice } from "@/lib/metrics";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import PerformanceProofChart from "./PerfomanceProofChart";
import { BtcPerfProof } from "@/lib/PerformanceProofSource";
import CryptoOverviewPanel from "@/app/components/CryptoOverviewPanel";
import WalletTablesRow from "./WalletTablesRow";
import UnlockSignalBanner from "@/app/components/UnlockSignalBanner";

export default function BtcPanel() {
  const t = useTranslations();

  return (
    <Box sx={{ display: "flex", alignItems: "stretch", width: "100%" }}>
      {/* 左侧菜单栏 */}
      <BtcPanelSideMenu />
      {/* 右侧主内容  width: { xs: "100%" } 让chart resize正常运行 */}
      <Box sx={{ flex: 1, pt: 4, px: 3, width: { xs: "100%", md: "auto" } }}>
        <UnlockSignalBanner />
        <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }} id="btc-pulse">
          {t.rich("Analytics.cryptoPulse", { crypto: "BTC" })}
        </Typography>
        <CryptoOverviewPanel crypto="btc" />
        <Box
          sx={{
            display: { xs: "block", md: "flex" },
            mt: 3,
            gap: 1,
            alignItems: "stretch",
          }}>
          <InvestingSignals crypto="btc" />
          <Chart metricId={BTCPrice.id} chartHeight="20rem" />
        </Box>
        <Box sx={{ mt: 1 }}>
          <PerformanceProofChart symbol="btc" perfProof={BtcPerfProof} chartHeight="27rem" />
        </Box>
        <Box sx={{ mt: 1, mb: 11, minWidth: 0 }}>
          <WalletTablesRow symbol="btc" />
        </Box>
      </Box>
    </Box>
  );
}
